import {HyperlinkEngine} from "../utilities/HyperlinkEngine";
import Routes from "./Routes";
import {Store} from "../store";
import ComponentClass from "../utilities/ComponentClass";

class RouterTransition extends ComponentClass.EventComponent {
    #hyperlinkElementList = [];
    #appElement;
    #nextRouteLocation = HyperlinkEngine.currentUrl.href;
    state = {
        suspended: false,
        navigation: false,
        dropdownVisibleInstance: null,
        initialized: false,
    }
    #config = {
        enterClassName: 'router-enter',
        leaveClassName: 'router-leave',
        enterActiveClassName: 'router-enter-active',
        durationEnter: 800,
        durationLeave: 600
    }

    constructor() {
        super();
        if (RouterTransition._instance) { // singleton pattern here bro!! because we need only one instance of this class
            return RouterTransition._instance;
        }
        RouterTransition._instance = this;
        this.#hyperlinkElementList = HyperlinkEngine.findHyperlinkElements();
        this.#appElement = Routes.App.element;
    }

    main() {
        if (this.state.initialized) return;
        Store.events.onDropdownShown(({detail}) => {
            this.setState({suspended: true});
            this.setState({dropdownVisibleInstance: detail.instance})
        }, false);
        Store.events.onDropdownHidden(({detail}) => {
            if (detail.instance !== this.state.dropdownVisibleInstance) return;
            this.setState({suspended: false});
            this.setState({dropdownVisibleInstance: null})
            if (this.state.navigation) {
                this.next();
            }
        });
        Store.events.on('state.change', ({detail}) => {
            this.attachClickListeners(detail.dropdownHyperLinks);
            this.#hyperlinkElementList.push(detail.dropdownHyperLinks);
        })
        this.attachClickListeners(this.#hyperlinkElementList);
        this.state.initialized = true;
    }

    attachClickListeners(links) {
        for (const HTMLLinkElement of links) {
            HTMLLinkElement.addEventListener('click', (event) => this.handleClick(event), false);
        }
    }

    enter({onEnterEnd: hook}) {
        this.main();
        this.#appElement.classList.remove(this.#config.leaveClassName);
        this.#appElement.classList.add(this.#config.enterClassName);
        setTimeout(() => {
            this.#appElement.classList.remove(this.#config.enterClassName);
            this.#appElement.classList.add(this.#config.enterActiveClassName);
            hook();
        }, this.#config.durationEnter)
    }

    leave({onLeaveEnd: hook}) {
        this.#appElement.classList.remove(this.#config.enterClassName);
        this.#appElement.classList.add(this.#config.leaveClassName);
        setTimeout(() => {
            hook();
        }, this.#config.durationLeave)
    }

    next() {
        if (this.#nextRouteLocation === HyperlinkEngine.currentUrl.href) return;
        this.leave({
            onLeaveEnd: () => {
                this.assignNextRoute();
            }
        })
    }

    handleClick(event) {
        event.preventDefault();
        if (HyperlinkEngine.isCurrentLocation(event.currentTarget)) return;
        this.#nextRouteLocation = new URL(event.currentTarget.href).href;
        if (event.ctrlKey || event.metaKey) {
            this.nextRouteOnWindow();
        } else if (this.state.suspended) {
            this.setState({navigation: true});
            this.state.dropdownVisibleInstance.hide();
        } else {
            this.next();
        }
    }

    assignNextRoute() {
        location.assign(this.#nextRouteLocation);
    }

    nextRouteOnWindow() {
        window.open(this.#nextRouteLocation);
    }

    get hyperlinkElementList() {
        return this.#hyperlinkElementList;
    }

    set hyperlinkElementList(value) {
        this.#hyperlinkElementList = value;
    }

    // Custom Events
    emitEventEntered() {
        this.dispatchEvent(
            new CustomEvent('transition.entered', {
                detail: {
                    element: this.#appElement,
                    instance: this
                }
            })
        );
    }
}

export const routerTransition = new RouterTransition();
